import { apiGet, apiPatch, apiDelete, apiPost } from '../../Dataman';
import { DEALS_PATHS } from './deals_paths';

const inFlightLists = new Map();

const buildKey = (params = {}) =>
  Object.keys(params)
    .sort()
    .map((key) => `${key}=${params[key]}`)
    .join('&');

const getTrackingList = (params) => {
  const key = buildKey(params);
  if (inFlightLists.has(key)) {
    return inFlightLists.get(key);
  }
  const request = apiGet(DEALS_PATHS.trackingParcels, { params }).finally(() => inFlightLists.delete(key));
  inFlightLists.set(key, request);
  return request;
};

export const trackingParcelsApiAdapter = {
  getTrackingInformations: (params) => getTrackingList(params),
  getTrackingInformation: (id) => getTrackingList({ deal: `${id}` }),
  updateTrackingInformation: (id, data) => apiPatch(`${DEALS_PATHS.trackingParcels}/${id}`, { data }),
  deleteTrackingInformation: (id) => apiDelete(`${DEALS_PATHS.trackingParcels}/${id}`),
  createTrackingInformation: (data) => {
    return apiPost(DEALS_PATHS.trackingParcels, { data: createTrackingParcelAdapter(data) });
  },
};

function createTrackingParcelAdapter(requestBody) {
  return {
    trackingNumber: requestBody.trackingNumber,
    courierDeliveryService: requestBody.courierDeliveryService.toString(),
    url: requestBody.url,
    note: requestBody.note,
    deal: requestBody.productOrder.toString(),
    countryOfDeparture: requestBody.countryOfDeparture.toString(),
    countryOfDestination: requestBody.countryOfDestination.toString(),
    visibleToCustomer: requestBody.visibleToCustomer,
    delivered: requestBody.delivered,
    departureAddress: requestBody.departureAddress,
    destinationAddress: requestBody.destinationAddress,
  };
}
